import { identity, identitySources } from '/Foundation/CDP/code/Utilities/cdpHelper';

const notifyMe = {
  clickElement: {
    open: document.getElementById('notifyMeButton'),
    closeBtns: document.querySelectorAll('.close-notify-modal'),
    closeOutside: document.getElementById('notifyModalBackdrop'),
    subscribe: document.getElementById('subscribeButton'),
  },
  modalElement: {
    wrapper: document.getElementById('notifyModalWrapper'),
    backdrop: document.getElementById('notifyModalBackdrop'),
    invalidEmailMessage: document.getElementById('invalidEmailMessage'),
    spinner: document.getElementById('notifyMeSpinner'),
    thankYouContent: document.querySelectorAll('.thankYouForSubscribing'),
    hideOnSuccessContent: document.querySelectorAll('.hideOnSuccess'),
    errorMessage: document.getElementById('errorMessage'),
    turnstileDiv: document.getElementById('notifyMeTurnstile'),
  },
  formElement: {
    userEmail: document.getElementById('notifyEmail'),
    consent1: document.getElementById('consent1'),
    consentText1: document.getElementById('consentText1'),
    productId: document.getElementById('notifyProductId'),
  },

  setEventListeners: function () {
    notifyMe.clickElement.open.addEventListener('click', () => {
      notifyMe.openModal();
    });

    Array.from(notifyMe.clickElement.closeBtns).forEach((btn) => {
      btn.addEventListener('click', () => {
        notifyMe.closeModal();
      });
    });

    notifyMe.clickElement.closeOutside.addEventListener('click', () => {
      notifyMe.closeModal();
    });

    notifyMe.clickElement.subscribe.addEventListener('click', (e) => {
      e.preventDefault();
      notifyMe.subscribe();
    });
  },

  openModal: function () {
    notifyMe.modalElement.wrapper.classList.add('notify-me-wrapper-open');
    notifyMe.modalElement.backdrop.classList.remove('d-none');
    document.body.classList.add('overflow-hidden');
    notifyMe.formElement.userEmail.focus();
  },

  closeModal: function () {
    notifyMe.modalElement.wrapper.classList.remove('notify-me-wrapper-open');
    notifyMe.modalElement.backdrop.classList.add('d-none');
    document.body.classList.remove('overflow-hidden');
  },

  subscribe: function () {
    let email = notifyMe.formElement.userEmail.value;
    let validatedEmail = notifyMe.validateEmail(email);

    if (!validatedEmail) {
      notifyMe.modalElement.invalidEmailMessage.classList.remove('d-none');
      notifyMe.formElement.userEmail.classList.add('subscribe-email-error');
      notifyMe.formElement.userEmail.focus();
    } else {
      notifyMe.modalElement.invalidEmailMessage.classList.add('d-none');
      notifyMe.formElement.userEmail.classList.remove('subscribe-email-error');
    }

    if (!notifyMe.formElement.consent1.checked) {
      notifyMe.formElement.consent1.classList.add('consent-checkbox-error');
      notifyMe.formElement.consentText1.classList.add('consent-text-error');
    } else {
      notifyMe.formElement.consent1.classList.remove('consent-checkbox-error');
      notifyMe.formElement.consentText1.classList.remove('consent-text-error');
    }

    if (notifyMe.formElement.consent1.checked && validatedEmail) {
      notifyMe.send();

      identity({ email: email, source: identitySources.notifyMe });
    }
  },

  validateEmail: function (email) {
    let validated = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,63})+$/.test(email);
    if (validated) {
      return true;
    } else {
      return false;
    }
  },

  send: function () {
    let turnstileToken = notifyMe.modalElement.turnstileDiv.querySelector('input[name=cf-turnstile-response]')?.value;
    if (!turnstileToken) return;

    let id = notifyMe.formElement.productId.innerHTML;
    let userEmail = notifyMe.formElement.userEmail.value;

    Array.from(notifyMe.modalElement.hideOnSuccessContent).forEach((elem) => elem.classList.add('d-none'));
    notifyMe.modalElement.errorMessage.classList.add('d-none');
    notifyMe.modalElement.spinner.classList.remove('d-none');

    fetch('/api/sitecore/product/AddUserToProductNotification', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ productId: id, email: userEmail, token: turnstileToken }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.Success) {
          notifyMe.clickElement.open.classList.remove('d-none');
          notifyMe.modalElement.spinner.classList.add('d-none');
          Array.from(notifyMe.modalElement.thankYouContent).forEach((elem) => elem.classList.remove('d-none'));
        } else {
          notifyMe.modalElement.spinner.classList.add('d-none');
          Array.from(notifyMe.modalElement.hideOnSuccessContent).forEach((elem) => elem.classList.remove('d-none'));
          // turnstile error
          notifyMe.modalElement.errorMessage.innerHTML = data.Message;
          notifyMe.modalElement.errorMessage.classList.remove('d-none');
          turnstile.reset();
        }
      })
      .catch((error) => {
        notifyMe.modalElement.spinner.classList.add('d-none');
        nArray.from(notifyMe.modalElement.hideOnSuccessContent).forEach((elem) => elem.classList.remove('d-none'));
        notifyMe.modalElement.errorMessage.innerHTML = 'Error';
        notifyMe.modalElement.errorMessage.classList.remove('d-none');
        console.error('Error:', error);
        turnstile.reset();
      });
  },
};

document.addEventListener('DOMContentLoaded', function () {
  notifyMe.setEventListeners();
});
